import { createSlice } from '@reduxjs/toolkit'


const initialState = {
    id: '',
    name: '',
    description: '',
    sections: [],
}

const stepSlice = createSlice({
    name: 'step',
    initialState,
    reducers: {
        stepUp: (state, action) => {
            // state.value += 1
            // state.section.order += 1
            // console.log("Step:", state.section.order)
        },

        stepBack: (state, action) => {
            // state.value -= 1
            // state.section.order -= 1
            // console.log("Step:", state.section.order)
        },

        setStep: (state, action) => {
            const { id, name, description, sections } = action.payload
            state.id = id;
            state.name = name;
            state.description = description;
            state.sections = sections;

            console.log("state.step:", state)
        },
        resetStep: (state, action) => {
            state.id = '';
            state.name = '';
            state.description = '';
            state.sections = [];
        }
    }
})

export const { stepUp, stepBack, setStep, resetStep } = stepSlice.actions

export default stepSlice.reducer